module.exports = __webpack_public_path__ + "e3a17466433a83c7eb9e02053518b703.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/clear-background-new.svg
// module id = 2478
// module chunks = 15